import { render, staticRenderFns } from "./FormDesktopMode.vue?vue&type=template&id=62829310&"
import script from "./FormDesktopMode.vue?vue&type=script&lang=js&"
export * from "./FormDesktopMode.vue?vue&type=script&lang=js&"
import style0 from "./FormDesktopMode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCheckbox,VFlex,VIcon,VImg,VLayout,VToolbar,VToolbarItems,VToolbarTitle})


/* vuetify-loader */
import installDirectives from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
installDirectives(component, {Resize})
